import { createOneAsicsApi } from '@asicsdigital/oneasics-blocks';

import { API_BASE_URL } from '../utilities/constants';

const { clientsApi, oauthApi, usersApi } = createOneAsicsApi({ baseUrl: API_BASE_URL });

export { clientsApi, oauthApi, usersApi };
